module.exports = __webpack_public_path__ + "img/ead-viamaker-white.90167f75.svg";